//@flow

import RequestNewsPost from './RequestNewsPost'

export default RequestNewsPost
